import { Upload, Spin, Typography, Button, Tooltip, notification, Card, Popconfirm, Result } from 'antd';
import React, { useState, useEffect } from 'react';
import { InboxOutlined, DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import { anonymize_instagram_data, anonymize_tiktok_data, anonymize_youtube_data } from './user_data_depersonaliser';
import {verify_tiktok_data} from './verifier_tiktok';
import {get_tiktok_data_stats, get_youtube_data_stats} from './duration_verifier';
import { checkWatchHistory, checkSearchHistory, getSubscriptions, getComments } from './verifier_youtube';
import {getInstagramComments} from './verifier_instagram';
import { SendToBackend, FetchFromBackend, ErrorConnectionFailed } from './HelperContactBackend';
import './Stepper.css';
import { Link } from 'react-router-dom';
import {calculate_payment_amount, calculate_payment_amount_instagram} from './utils';
import JSZip from 'jszip';
import { excludedOptions } from './DataDonationOptions';

var md5 = require('md5');

const { Dragger } = Upload;
const { Text, Title } = Typography;

export const PageUpload = ({ next,
    prev,
    moveToEnd,
    payingParticipants,
    donationOptions,
    sessionId,
    platform,
    emailIdentifier,
    amountTobePayed,
    setAmountToBePayed,
    userData,
    setUserData,
    setDemographicSurveyQuestions,
    setTechsavvinessSurveyQuestions,
    setUsageSurveyQuestions }) => {

    const [fileCheck, setFileCheck] = useState(false);
    const [fileName, setFileName] = useState(null);
    const [submissionStage, setSubmissionStage] = useState("RequestFile");
    const [fileReceived, setFileReceived] = useState(null);
    const [watchHistory, setWatchHistory] = useState(null);
    const [searchHistory, setSearchHistory] = useState(null);
    const [comments, setComments] = useState(null);
    const [subscriptions, setSubscriptions] = useState(null);
    const [likedVideos, setLikedVideos] = useState(null);

    const [adsAndTopics, setAdsAndTopics] = useState(null);
    const [adsAndBusinesses, setAdsAndBusinesses] = useState(null);
    const [yourTopics, setYourTopics] = useState(null);
    const [appsAndWebsites, setAppsAndWebsites] = useState(null);
    const [recentSearches, setRecentSearches] = useState(null);
    const [linkHistory, setLinkHistory] = useState(null);
    const [subscriptionsInstagram, setSubscriptionsInstagram] = useState(null);
    const [storyInteractions, setStoryInteractions] = useState(null);
    const [saved, setSaved] = useState(null);
    const [likes, setLikes] = useState(null);
    const [commentsInstagram, setCommentsInstagram] = useState(null);

    const confirmText = 'Are you sure you want to submit your data? If you click "Yes", your anonymized donated data will be transferred to our database.'

    const openNotificationFileAccepted = () => {
        notification["success"]({
            message: <Text strong>{'File Combatible'}</Text>,
            description:
                "The selected file has the expected format. If for any reason you wish to remove the selected file, press the bin icon next to the file's name.",
        });
    };

    const openNotificationFileRejected = (errorList) => {
        notification["error"]({
            message: <Text strong>{'File Incompatible'}</Text>,
            className: "Text",
            description:
                <div>
                    <Text>{"The selected file does not have the expected format. Please ensure that you select either an unmodified file downloaded directly from TikTok or a file that has been modified only by our anonymization scripts.\n\n"}</Text>
                    <Text strong>{"The following errors were found:\n- " + errorList.join("\n- ")}</Text>
                </div>,
        });
    };

    const openNotificationFileRejectedRequirements = (info) => {
        notification["error"]({
            message: <Text strong>{'Study Requirements not met!'}</Text>,
            className: "Text",
            description:
                <div>
                    <Text>{"The selected file does not meet the minimum use requirements for our study!\n"}</Text>
                    <Text strong>{"Duration of watch history:" + info['duration'] + " day(s)." }</Text>
                </div>,
        });
    };

    const openNotificationFileRejectedYouTube = (errorList) => {
        notification["error"]({
            message: <Text strong>{'File Incompatible'}</Text>,
            className: "Text",
            description:
                <div>
                    <Text>{"The selected file does not have the expected format. Please ensure that you select either an unmodified file downloaded directly from YouTube or a file that has been modified only by our anonymization scripts.\n\n"}</Text>
                    <Text strong>{"The following error was found:\n- " + errorList.join("\n- ")}</Text>
                </div>,
        });
    };

    const openNotificationFileRejectedInstagram = (errorList) => {
        notification["error"]({
            message: <Text strong>{'File Incompatible'}</Text>,
            className: "Text",
            description:
                <div>
                    <Text>{"The selected file does not have the expected format. Please ensure that you select either an unmodified file downloaded directly from Instagram or a file that has been modified only by our anonymization scripts.\n\n"}</Text>
                    <Text strong>{"The following error was found:\n- " + errorList.join("\n- ")}</Text>
                </div>,
        });
    };    

    const beforeUploadTikTok = (file) => {
        setFileCheck(true);
        var extension = file.name.split('.').pop();
        //console.log(extension);
        if(extension=='json'){
            const reader = new FileReader();
            reader.readAsText(file);
            reader.onload = function () {
                try{
                const fileData = JSON.parse(reader.result);
                const errors = verify_tiktok_data(fileData,
                    donationOptions.LikeHistory,
                    donationOptions.SearchHistory,
                    donationOptions.ShareHistory,
                    donationOptions.SessionHistory,
                    donationOptions.TikTokFavourites,
                    donationOptions.TikTokFollowing,
                    donationOptions.TikTokFollowers,
                    donationOptions.Comments,
                    donationOptions.CommentText,
                    donationOptions.AdData,
                    donationOptions.TikTokAppSettings);
                if (errors.length === 0) {
                    var stats = get_tiktok_data_stats(fileData);

                    // console.log(stats);

                    // CHANGE THIS BACK TO 90
                    const min_duration = 90;

                    if (stats['duration']>=min_duration){
                        setFileName(file.name);
                        setFileReceived(true);
                        setUserData(fileData);
                        openNotificationFileAccepted();
                    }
                    else{
                        openNotificationFileRejectedRequirements(stats);
                    }
                }
                else {
                    openNotificationFileRejected(errors);
                }
                }
                catch(e){
                    // console.log(e);
                    openNotificationFileRejected(['File not supported!']);
                }
                setFileCheck(false);
            }
        }
        else if(extension=='zip'){
            //console.log("WE need to handle the zip input!");
            var zip = new JSZip();
            try{
                zip.loadAsync(file).then(function(content) {
                    // process ZIP file content here
                    // console.log(content);
                    // console.log(content.files);
                    if(zip.file('/user_data.json') != null){
                        return content.files["/user_data.json"].async('text');
                    }
                    else if(zip.file('user_data.json') != null){
                        return content.files["user_data.json"].async('text');
                    }
                    else if(zip.file('/user_data_tiktok.json') != null){
                        return content.files["/user_data_tiktok.json"].async('text');
                    }
                    else if(zip.file('user_data_tiktok.json') != null){
                        return content.files["user_data_tiktok.json"].async('text');
                    }
                    else{
                        // console.log('user data json not found');
                        return null;
                    }
                }).then(function(fileText){
                    if(fileText!=null){
                        //console.log("file identified in zip");
                        try {
                            const fileData = JSON.parse(fileText);
                            const errors = verify_tiktok_data(fileData,
                                donationOptions.LikeHistory,
                                donationOptions.SearchHistory,
                                donationOptions.ShareHistory,
                                donationOptions.SessionHistory,
                                donationOptions.TikTokFavourites,
                                donationOptions.TikTokFollowing,
                                donationOptions.TikTokFollowers,
                                donationOptions.Comments,
                                donationOptions.CommentText,
                                donationOptions.AdData,
                                donationOptions.TikTokAppSettings);
                            if (errors.length === 0) {
                                var stats = get_tiktok_data_stats(fileData);
                                // console.log(stats);
                                const min_duration = 90;
                                if (stats['duration']>=min_duration){
                                    setFileName(file.name);
                                    setFileReceived(true);
                                    setUserData(fileData);
                                    openNotificationFileAccepted();
                                }
                                else{
                                    openNotificationFileRejectedRequirements(stats);
                                }
                            }
                            else {
                                openNotificationFileRejected(errors);
                            }
                        } catch {
                                // console.log('second instance');
                                openNotificationFileRejected(['File not supported!']);
                        }
                        setFileCheck(false);
                    } else {
                        //console.log("Couldnt find the file in zip");
                        openNotificationFileRejected(['Incompatible .zip file! Make sure to use the .zip file downloaded from the TikTok app.']);
                        //setFileReceived(false);
                        setFileCheck(false);
                        return false;
                    }
                });
            }
            catch{
                // console.log('third instance');
                openNotificationFileRejected(['File not supported!'])
            }

            //}, function() {console.log("Not a valid zip file")}); 
       
        }
        // Abort any attempted upload. 
        return false;
    };

    const beforeUploadYouTube = (file) => {
        setFileCheck(true);
        var extension = file.name.split('.').pop();
        // console.log(extension);
        if (extension == 'zip') {
            var zip = new JSZip();
            try {
                zip.loadAsync(file).then(async function(content) {
                    var errors = [];
                    var watch_history_path = 'Takeout/YouTube and YouTube Music/history/watch-history.json';
                    if (zip.file(watch_history_path) != null ) {
                        const error = await content.files[watch_history_path].async('text').then(function(fileText) {
                            var faced_error = 0
                            var watch_history = JSON.parse(fileText);
                            if (checkWatchHistory(watch_history)) {
                                var stats = get_youtube_data_stats(watch_history);
                                const min_duration = 90;
                                if (stats['duration'] < min_duration) {
                                    faced_error = 2;
                                    openNotificationFileRejectedRequirements(stats);
                                }
                                else {
                                    setWatchHistory(watch_history);
                                }
                            } else {
                                faced_error = 1;
                            }
                            return faced_error;                            
                        });
                        if (error == 1) {
                            errors.push('Watch history not detected!');
                        }
                        if (error == 2) {
                            errors.push('Minimum use requirements not met!');
                        }
                    } else {
                        errors.push('Watch history not detected!');
                    }
                    if (donationOptions.SearchHistory) {
                        var search_history_path = 'Takeout/YouTube and YouTube Music/history/search-history.json';
                        if (zip.file(search_history_path) != null ) {
                            const error = await content.files[search_history_path].async('text').then(function(fileText) {
                                var faced_error = 0;
                                var search_history = JSON.parse(fileText);
                                if (checkSearchHistory(search_history)) {
                                    setSearchHistory(search_history);
                                } else {
                                    faced_error = 1;
                                }
                                return faced_error;
                            });
                            if (error == 1) {
                                errors.push('Search history not detected!');
                            }
                        } else {
                            errors.push('Search history not detected!');
                        }
                    }
                    if (donationOptions.Comments) {
                        var comments_path = 'Takeout/YouTube and YouTube Music/comments/comments.csv';
                        if (zip.file(comments_path) != null ) {
                            const error = await content.files[comments_path].async('text').then(function(fileText) {
                                var faced_error = 0;
                                var comments = getComments(fileText, !donationOptions.CommentText);
                                if (comments !== null) {
                                    setComments(comments);
                                } else {
                                    faced_error = 1;
                                }
                                return faced_error;
                            });
                            if (error == 1){
                                errors.push('Comments not detected!');
                            }
                        } else {
                            errors.push('Comments not detected!');
                        }
                    }
                    if (donationOptions.YouTubeSubscriptions) {
                        var subscriptions_path = 'Takeout/YouTube and YouTube Music/subscriptions/subscriptions.csv';
                        if (zip.file(subscriptions_path) != null ) {
                            const error = await content.files[subscriptions_path].async('text').then(function(fileText) {
                                var faced_error = 0;
                                var subscriptions = getSubscriptions(fileText);
                                if (subscriptions !== null) {
                                    setSubscriptions(subscriptions);
                                } else {
                                    faced_error = 1;
                                }
                                return faced_error;
                            });
                            if (error == 1){
                                errors.push('Subscriptions not detected!');
                            }
                        } else {
                            errors.push('Subscriptions not detected!');
                        }
                    }
                    return errors;
                }).then(function(x) {
                    if (x.length == 0) {
                        setFileName(file.name);
                        setFileReceived(true);
                        openNotificationFileAccepted();                    
                    } else {
                        openNotificationFileRejectedYouTube(x);
                    }
                });
            }
            catch {
                openNotificationFileRejected(['File not supported!'])
            }
            setFileCheck(false);
        }
        return false;
    };

    async function process_input_instagram() {

    }

    const beforeUploadInstagram = (file) => {
        setFileCheck(true);
        var extension = file.name.split('.').pop();
        if (extension == 'zip') {
            var zip = new JSZip();
            try {
                zip.loadAsync(file).then(async function(content) {
                    var errors = [];
                    console.log(donationOptions);

                    if (donationOptions.AdsAndTopics) {
                        var localAdsAndTopics = {};
                        for (const fileName in content.files) {
                            console.log(fileName);
                            const file = content.files[fileName];
                            if (file.dir == false && file.name.startsWith('ads_information/ads_and_topics/') && file.name.endsWith('.json')) {
                                const error = await content.files[file.name].async('text').then(function(fileText) {
                                    var jsonData = JSON.parse(fileText);
                                    localAdsAndTopics[file.name] = jsonData;
                                });
                            }
                        }
                        if (Object.keys(localAdsAndTopics).length == 0) {
                            errors.push('Ads and Topics not detected!');
                        } else {
                            setAdsAndTopics(localAdsAndTopics);
                        }
                    }
                    
                    if (donationOptions.InstagramAdsAndBusinesses) {
                        var localAdsAndBusinesses = {};
                        for (const fileName in content.files) {
                            const file = content.files[fileName];
                            if (file.dir == false && file.name.startsWith('ads_information/instagram_ads_and_businesses/') && file.name.endsWith('.json')) {
                                const error = await content.files[file.name].async('text').then(function(fileText) {
                                    var jsonData = JSON.parse(fileText);
                                    localAdsAndBusinesses[file.name] = jsonData;
                                });
                            }
                        }                      
                        if (Object.keys(localAdsAndBusinesses).length == 0) {
                            errors.push('Ads and Businesses not detected!');
                        } else {
                            setAdsAndBusinesses(localAdsAndBusinesses);
                        }
                    }

                    if (donationOptions.InstagramYourTopics) {
                        var localYourTopics = {};
                        for (const fileName in content.files) {
                            const file = content.files[fileName];
                            if (file.dir == false && file.name.startsWith('preferences/your_topics/') && file.name.endsWith('.json')) {
                                const error = await content.files[file.name].async('text').then(function(fileText) {
                                    var jsonData = JSON.parse(fileText);
                                    localYourTopics[file.name] = jsonData;
                                });
                            }
                        }             
                        if (Object.keys(localYourTopics).length == 0) {
                            errors.push('Your Topics not detected!');
                        } else {
                            setYourTopics(localYourTopics);
                        }
                    }

                    if (donationOptions.InstagramAppsAndWebsites) {
                        var localAppsAndWebsites = {};
                        for (const fileName in content.files) {
                            const file = content.files[fileName];
                            if (file.dir == false && file.name.startsWith('apps_and_websites_off_of_instagram/apps_and_websites/') && file.name.endsWith('.json')) {
                                const error = await content.files[file.name].async('text').then(function(fileText) {
                                    var jsonData = JSON.parse(fileText);
                                    localAppsAndWebsites[file.name] = jsonData;
                                });
                            }
                        }              
                        if (Object.keys(localAppsAndWebsites).length == 0) {
                            errors.push('Apps and Websites not detected!');
                        } else {
                            setAppsAndWebsites(localAppsAndWebsites);
                        }
                    }                    

                    if (donationOptions.InstagramRecentSearches) {
                        var localRecentSearches = {};
                        for (const fileName in content.files) {
                            const file = content.files[fileName];
                            if (file.dir == false && file.name.startsWith('logged_information/recent_searches/') && file.name.endsWith('.json')) {
                                const error = await content.files[file.name].async('text').then(function(fileText) {
                                    var jsonData = JSON.parse(fileText);
                                    localRecentSearches[file.name] = jsonData;
                                });
                            }
                        }                  
                        if (Object.keys(localRecentSearches).length == 0) {
                            errors.push('Recent Searches not detected!');
                        } else {
                            setRecentSearches(localRecentSearches);
                        }
                    }                    

                    if (donationOptions.InstagramLinkHistory) {
                        var localLinkHistory = {};
                        for (const fileName in content.files) {
                            const file = content.files[fileName];
                            if (file.dir == false && file.name.startsWith('logged_information/link_history/') && file.name.endsWith('.json')) {
                                const error = await content.files[file.name].async('text').then(function(fileText) {
                                    var jsonData = JSON.parse(fileText);
                                    localLinkHistory[file.name] = jsonData;
                                });
                            }
                        }                 
                        if (Object.keys(localLinkHistory).length == 0) {
                            errors.push('Link History not detected!');
                        } else {
                            setLinkHistory(localLinkHistory);
                        }
                    }

                    if (donationOptions.InstagramSubscriptions) {
                        var localSubscriptions = {};
                        for (const fileName in content.files) {
                            const file = content.files[fileName];
                            if (file.dir == false && file.name.startsWith('your_instagram_activity/subscriptions/') && file.name.endsWith('.json')) {
                                const error = await content.files[file.name].async('text').then(function(fileText) {
                                    var jsonData = JSON.parse(fileText);
                                    localSubscriptions[file.name] = jsonData;
                                });
                            }
                        }                    
                        if (Object.keys(localSubscriptions).length == 0) {
                            errors.push('Subscriptions not detected!');
                        } else {
                            setSubscriptionsInstagram(localSubscriptions);
                        }
                    }                    

                    if (donationOptions.InstagramStoryInteractions) {
                        var localStoryInteractions = {};
                        for (const fileName in content.files) {
                            const file = content.files[fileName];
                            if (file.dir == false && file.name.startsWith('your_instagram_activity/story_sticker_interactions/') && file.name.endsWith('.json')) {
                                const error = await content.files[file.name].async('text').then(function(fileText) {
                                    var jsonData = JSON.parse(fileText);
                                    localStoryInteractions[file.name] = jsonData;
                                });
                            }
                        }                    
                        if (Object.keys(localStoryInteractions).length == 0) {
                            errors.push('Story Interactions not detected!');
                        } else {
                            setStoryInteractions(localStoryInteractions);
                        }
                    }

                    if (donationOptions.InstagramSaved) {
                        var localSaved = {};
                        for (const fileName in content.files) {
                            const file = content.files[fileName];
                            if (file.dir == false && file.name.startsWith('your_instagram_activity/saved/') && file.name.endsWith('.json')) {
                                const error = await content.files[file.name].async('text').then(function(fileText) {
                                    var jsonData = JSON.parse(fileText);
                                    localSaved[file.name] = jsonData;
                                });
                            }
                        }                        
                        if (Object.keys(localSaved).length == 0) {
                            errors.push('Saved not detected!');
                        } else {
                            setSaved(localSaved);
                        }
                    }

                    if (donationOptions.InstagramLikes) {
                        var localLikes = {};
                        for (const fileName in content.files) {
                            const file = content.files[fileName];
                            if (file.dir == false && file.name.startsWith('your_instagram_activity/likes/') && file.name.endsWith('.json')) {
                                const error = await content.files[file.name].async('text').then(function(fileText) {
                                    var jsonData = JSON.parse(fileText);
                                    localLikes[file.name] = jsonData;
                                });
                            }
                        }                        
                        if (Object.keys(localLikes).length == 0) {
                            errors.push('Likes not detected!');
                        } else {
                            setLikes(localLikes);
                        }
                    }

                    if (donationOptions.InstagramComments) {
                        var localComments = {};
                        for (const fileName in content.files) {
                            const file = content.files[fileName];
                            if (file.dir == false && file.name.startsWith('your_instagram_activity/comments/') && file.name.endsWith('.json')) {
                                const error = await content.files[file.name].async('text').then(function(fileText) {
                                    var jsonData = JSON.parse(fileText);
                                    jsonData = getInstagramComments(jsonData);
                                    // console.log("Parsed JSON data:", jsonData);
                                    localComments[file.name] = jsonData;
                                });
                            }
                        }
                        if (Object.keys(localComments).length == 0) {
                            errors.push('Comments not detected!');
                        } else {
                            setCommentsInstagram(localComments);
                        }
                    }
                    return errors;
                }).then(function(x) {
                    if (x.length == 0) {
                        setFileName(file.name);
                        setFileReceived(true);
                        openNotificationFileAccepted();                    
                    } else {
                        openNotificationFileRejectedInstagram(x);
                    }
                });
            }
            catch {
                openNotificationFileRejected(['File not supported!'])
            }
            setFileCheck(false);
        }
        return false;
    };

    var beforeUploadFunction = null;

        switch (platform) {
        case "tiktok":
            beforeUploadFunction = beforeUploadTikTok;
            break;
        case "youtube":
            beforeUploadFunction = beforeUploadYouTube;
            break;
        case "instagram":
            beforeUploadFunction = beforeUploadInstagram;
            break;
    }    

    const removeFile = () => {
        setFileReceived(false);
        setFileName(null);
    };

    const onClickSubmit = () => {
        setSubmissionStage("Transfer");
        // Platform is TikTok
        if (platform === "tiktok") {
            const depData = anonymize_tiktok_data(
                userData,
                donationOptions.LikeHistory,
                donationOptions.SearchHistory,
                donationOptions.ShareHistory,
                donationOptions.SessionHistory,
                donationOptions.TikTokFavourites,
                donationOptions.TikTokFollowing,
                donationOptions.TikTokFollowers,
                donationOptions.Comments,
                donationOptions.CommentText,
                donationOptions.AdData,
                donationOptions.TikTokAppSettings
            );
            //console.log(depData);
            var submission = JSON.stringify({
                "session_id": sessionId.session_id,
                "platform": platform,
                "donated_data": depData,
                "donated_options": donationOptions,
                "source": "unknown",
                "email_md5": md5(emailIdentifier)
            });
            SendToBackend(submission,
                'donations/',
                () => {
                    var payment_amount = calculate_payment_amount(
                        donationOptions.LikeHistory,
                        donationOptions.SearchHistory,
                        donationOptions.ShareHistory,
                        donationOptions.SessionHistory,
                        donationOptions.TikTokFavourites,
                        donationOptions.TikTokFollowing,
                        donationOptions.TikTokFollowers,
                        donationOptions.Comments,
                        donationOptions.CommentText,
                        donationOptions.AdData,
                        donationOptions.TikTokAppSettings,
                        false
                    );
                    //console.log("Payment amount to be added = " + payment_amount);
                    setAmountToBePayed(payment_amount);
                    var payment_submission = JSON.stringify({
                        "email": emailIdentifier,
                        "email_md5": md5(emailIdentifier),
                        "platform": platform,
                        "bonus_payment": payment_amount,
                        "donation_options": donationOptions,
                        "survey_completed": false
                    });
                    // console.log(payment_submission);
                    SendToBackend(payment_submission,
                        'payments/',
                        () => {
                            setSubmissionStage("Done");
                            setUserData(null);
                        },
                        () => {
                            setSubmissionStage("RequestFile");
                            ErrorConnectionFailed();
                        });         
                },
                () => {
                    setSubmissionStage("RequestFile");
                    removeFile();
                    ErrorConnectionFailed();
                });
               
        }
        // platform is YouTube
        else if (platform === "youtube") {

            const depData = anonymize_youtube_data(
                watchHistory,
                searchHistory,
                comments,
                subscriptions,
                likedVideos,
            );

            var submission = JSON.stringify({
                "session_id": sessionId.session_id,
                "platform": platform,
                "donated_data": depData,
                "donated_options": donationOptions,
                "source": "unknown",
                "email_md5": md5(emailIdentifier)
            });
            
            SendToBackend(submission,
                'donations/',
                () => {
                    var payment_amount = calculate_payment_amount(
                        donationOptions.LikeHistory,
                        donationOptions.SearchHistory,
                        false,
                        false,
                        false,
                        donationOptions.YouTubeSubscriptions,
                        false,
                        donationOptions.Comments,
                        donationOptions.CommentText,
                        false,
                        false,
                        false
                    );
                    //console.log("Payment amount to be added = " + payment_amount);
                    setAmountToBePayed(payment_amount);
                    var payment_submission = JSON.stringify({
                        "email": emailIdentifier,
                        "email_md5": md5(emailIdentifier),
                        "platform": platform,
                        "bonus_payment": payment_amount,
                        "donation_options": donationOptions,
                        "survey_completed": false
                    });
                    // console.log(payment_submission);
                    SendToBackend(payment_submission,
                        'payments/',
                        () => {
                            setSubmissionStage("Done");
                            setWatchHistory(null);
                            setSearchHistory(null);
                            setComments(null);
                            setSubscriptions(null);
                            setLikedVideos(null);
                        },
                        () => {
                            setSubmissionStage("RequestFile");
                            ErrorConnectionFailed();
                        });         
                },
                () => {
                    setSubmissionStage("RequestFile");
                    removeFile();
                    ErrorConnectionFailed();
                });
        } 

        else if (platform === "instagram") {

            const depData = anonymize_instagram_data(
                adsAndTopics,
                adsAndBusinesses,
                yourTopics,
                appsAndWebsites,
                recentSearches,
                linkHistory,
                subscriptionsInstagram,
                storyInteractions,
                saved,
                likes,
                commentsInstagram,
            );

            var submission = JSON.stringify({
                "session_id": sessionId.session_id,
                "platform": platform,
                "donated_data": depData,
                "donated_options": donationOptions,
                "source": "unknown",
                "email_md5": md5(emailIdentifier)
            });

            SendToBackend(submission,
                'donations/',
                () => {
                    var payment_amount = calculate_payment_amount_instagram(
                        donationOptions.InstagramAdsAndBusinesses,
                        donationOptions.InstagramYourTopics,
                        donationOptions.InstagramAppsAndWebsites,
                        donationOptions.InstagramRecentSearches,
                        donationOptions.InstagramLinkHistory,
                        donationOptions.InstagramSubscriptions,
                        donationOptions.InstagramStoryInteractions,
                        donationOptions.InstagramSaved,
                        donationOptions.InstagramLikes,
                        donationOptions.InstagramComments, 
                        false,
                    );
                    
                    console.log("Payment amount to be added = " + payment_amount);

                    setAmountToBePayed(payment_amount);
                    var payment_submission = JSON.stringify({
                        "email": emailIdentifier,
                        "email_md5": md5(emailIdentifier),
                        "platform": platform,
                        "bonus_payment": payment_amount,
                        "donation_options": donationOptions,
                        "survey_completed": false
                    });
                    SendToBackend(payment_submission,
                        'payments/',
                        () => {
                            setSubmissionStage("Done");
                            setAdsAndTopics(null);
                            setAdsAndBusinesses(null);
                            setYourTopics(null);
                            setAppsAndWebsites(null);
                            setRecentSearches(null);
                            setLinkHistory(null);
                            setSubscriptionsInstagram(null);
                            setStoryInteractions(null);
                            setSaved(null);
                            setLikes(null);
                            setCommentsInstagram(null);
                        },
                        () => {
                            setSubmissionStage("RequestFile");
                            ErrorConnectionFailed();
                        });         
                },
                () => {
                    setSubmissionStage("RequestFile");
                    removeFile();
                    ErrorConnectionFailed();
                });            


        }
    }

    // Used to track how many initial connections (e.g. session id, survey question retrieval) were successful.
    const [nSuccessfulConnections, setNSuccessfulConnections] = useState(0);
    var failedConnectionReported = false;

    const ReportSuccessfulConnection = () => {
        setNSuccessfulConnections(prevNSuccessfulConnections => {
            setNSuccessfulConnections(prevNSuccessfulConnections + 1)
        })
    };

    const ShowSingleError = () => {
        if (!failedConnectionReported) {
            ErrorConnectionFailed();
            failedConnectionReported = true;
        }
    };

    function continueToSurvey() {
        // Demographics questions
        FetchFromBackend('questions/platform/' + platform + '/type/demographics',
            ReportSuccessfulConnection,
            ShowSingleError,
            setDemographicSurveyQuestions);

        // Usage questions
        FetchFromBackend('questions/platform/' + platform + '/type/platform-use',
            ReportSuccessfulConnection,
            ShowSingleError,
            (questions) => { setUsageSurveyQuestions(questions) });

        // Tech savviness questions
        FetchFromBackend('questions/platform/' + platform + '/type/techsaviness',
            ReportSuccessfulConnection,
            ShowSingleError,
            (questions) => { setTechsavvinessSurveyQuestions(questions) });

    }

    function finishWithoutSurvey(){
        //console.log("Finish without survey");
        moveToEnd();
    }

    // When all survey questions are successfully retrieved, go to the next step.
    useEffect(() => {
        if (nSuccessfulConnections === 3) {
            next();
            setNSuccessfulConnections(0);
        }
    }, [nSuccessfulConnections]);

    const FileUpload = () => {
        return (
            <Dragger
                name='file'
                accept={(platform === "tiktok") ? '.json,.zip' : '.zip'}
                beforeUpload={beforeUploadFunction}
                showUploadList={false}
                disabled={fileCheck || fileReceived}
                multiple={false}>
                <Spin spinning={fileCheck} tip="Your anonymised file is being checked and depersonalised." />
                <p className="ant-upload-drag-icon">
                    <InboxOutlined style={{ color: (fileCheck || fileReceived) ? 'gray' : '#5497CC' }} />
                </p>
                <p className="ant-upload-text">
                    Click or drag file to this area to begin the processing of your data {(platform === 'tiktok') ? '(.json or .zip file)' : '(.zip file)'}
                </p>
                <p className="ant-upload-hint">
                    
                </p>
            </Dragger>
        );
    }

    const FileTracker = () => {
        return (
            <div hidden={false}>
                <Text className="UploadText"> {fileName}</Text>
                <Tooltip placement="right" title="Delete uploaded file">
                    <Button className="UploadText" type="text" icon={<DeleteOutlined />} onClick={removeFile} hidden={!fileReceived} />
                </Tooltip>
            </div>
        );
    }

    const SubmitButton = () => {
        return (
            <div>
                <Popconfirm title={confirmText} onConfirm={onClickSubmit} okText="Yes" cancelText="No">
                    <Button
                        className="TopMargin"
                        type="primary"
                        shape="round"
                        icon={<UploadOutlined />}
                        size="large"
                        disabled={!fileReceived}>
                        Submit
                    </Button>
                </Popconfirm>
            </div>
        );
    }

    const OptionCard = () => {
        return (
            <Card className="OptionCard">
                <div><Text className="OptionCard" strong={true}>Note:</Text> Our website automatically removes all personal identifiers as mentioned earlier and changes the input file so that we only collect the parts of the data you opted-in. We also provide the same functionality in an offline depersonalizer using a Python script. More information on how you can depersonalize your data using our Python script can be found <a href="https://github.com/zsavvas/TikTok-utils " target="_blank">here</a> (this is optional and this is in case you want to edit automatically and review the file before using our website). Our website performs the same operations as the Python script on the browser and on the client-side (<strong>we do not transfer the raw personalized data to our server!</strong>).</div>
            </Card>
        );
    }

    const Spinner = () => {
        return (
            <div hidden={!(submissionStage === "Transfer")} className="TopMargin">
                <Spin size="large" tip="Your file is being transferred to our database." />
            </div>
        );
    }

    const DoneScreen = () => {
        return (
            <div hidden={!(submissionStage === "Done")}>
                <Card>
                    <Card.Meta description={
                        <div className="Text">
                            <Text hidden={payingParticipants}>The next step is about filling out an optional survey.
                                Please note that you have already filled out the exact same survey on Google Forms.
                                Therefore, by retaking the survey you will NOT be compensated by any additional amount.
                                Still, if you would like to, please feel free to retake the survey by clicking the "Continue to Survey" button below.
                                Otherwise, please click the "Finish" button to complete the data donation without retaking the survey.</Text>
                            <Text hidden={!payingParticipants}>The next step is about filling out an optional survey.
                                Please note that you have already filled out the exact same survey on Google Forms.
                                Therefore, by retaking the survey you will NOT be compensated by any additional amount.
                                Still, if you would like to, please feel free to retake the survey by clicking the "Continue to Survey" button below.
                                Otherwise, please click the "Finish" button to complete the data donation without retaking the survey.</Text>
                        </div>
                    }
                    />
                </Card>
                <div>
                    <Button type="primary" onClick={continueToSurvey} className="SurveyButton">Continue to Survey</Button>
                </div>
                <div>
                    <Button type="primary" onClick={finishWithoutSurvey} className="SurveyButton">Finish</Button>
                </div>
            </div>
        );
    }

    const NavigationButtons = () => {
        return (
            <div style={{ marginTop: "1em" }} hidden={submissionStage === "Done"}>
                <Button
                    className="RightMargin"
                    onClick={prev}>
                    Previous
                </Button>
                <Button
                    type="primary"
                    onClick={next}
                    disabled>
                    Next
                </Button>
            </div>
        );
    }

    return (
        <div>
            <div hidden={submissionStage !== "RequestFile"}>
                <FileUpload />
                <FileTracker />
                <SubmitButton />
                <OptionCard />
            </div>
            <Spinner />
            <DoneScreen />
            <NavigationButtons />
        </div>
    );
}

export default PageUpload;